import React, { useState } from 'react'
import { Modal, OverlayTrigger, Spinner } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { renderTooltipClose } from 'utlis/helpers/Tooltips/CommonTooltips'
import { toast } from 'react-toastify';
import { resetPassCustomer } from 'utlis/Apis/Customers_API';
import { CUSTOMER_UPDATED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE_UPDATING_CUSTOMER } from 'utlis/AppMessages/AppMessages';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';
import { connect } from 'react-redux';

function ResetPassword(props) {
    const { authState, show, closeModal, user_id } = props
    const [modalLoading, setModalLoading] = useState(false)
    const [password, setPassword] = useState("")

    const handleReset = () => {
        toast.dismiss();
        if (!password) {
            toast.error("Enter Password", {
                autoClose: 2000
            })
            return
        }
        setModalLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        resetPassCustomer(headers, user_id, password).then(res => {
            setModalLoading(false)
            const deletedData = res.data
            if (deletedData.success) {
                closeModal()
                toast.success(CUSTOMER_UPDATED_SUCCESSFULLY, {
                    autoClose: 2500,
                })
            }

            if (deletedData.error) {
                console.log(ERROR_WHILE_UPDATING_CUSTOMER, res)
                toast.dismiss();
                toast.error(ERROR_WHILE_UPDATING_CUSTOMER, {
                    autoClose: 2500,
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE_UPDATING_CUSTOMER} deleteCustomer `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
            })
        })
    }

    return (
        <Modal show={show} onHide={closeModal} centered size="md">
            <Modal.Body className="st-modal pad-20">
                <div className="app-modal-content modal_add-customer p-0 min-height-auto">
                    <div className="add-customer-form">
                        <div className="d-flex justify-content-between">
                            <div className="app-modal-title-wrapper mb-2 mb-lg-3 p-0">
                                <p className="app-modal-title text-capitalize st-fw-600">Reset Password</p>
                            </div>
                            <OverlayTrigger
                                placement={"bottom"}
                                overlay={renderTooltipClose}
                            >
                                <button
                                    className="st-round-btn st-btn-transparent  st-btn-sm d-flex align-items-center justify-content-center"
                                    onClick={closeModal}
                                >
                                    <FeatherIcon
                                        icon="x"
                                        size="24"
                                        className="icon border st-default-rounded-block" />
                                </button>
                            </OverlayTrigger>
                        </div>
                        <div className="app-card customer-address-modal" >
                            <div className="app-card-content border st-default-rounded-block pad-20">
                                <div className="st-form">
                                    <label>Password</label>
                                    <div className="media-body st-form-input-container">
                                        <input
                                            className="form-control"
                                            placeholder="Enter New Password"
                                            id="password"
                                            value={password}
                                            type="password"
                                            onChange={(e) => { setPassword(e.target.value) }}
                                        >
                                        </input>
                                    </div>
                                </div>

                                <div className="btns d-flex justify-content-end pt-3">
                                    <button
                                        disabled={modalLoading}
                                        onClick={closeModal}
                                        className="st-btn st-btn-gray no-min-width d-flex align-items-center justify-content-center me-1">
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="st-btn st-btn-primary no-min-width d-flex align-items-center justify-content-center"
                                        disabled={modalLoading}
                                        onClick={handleReset}
                                    >
                                        <span>Reset</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        {
                            modalLoading &&
                            <div className="app-modal-loading-overlay position-absolute h-100 w-100 d-flex align-items-center justify-content-center">
                                <Spinner animation="border" />
                            </div>
                        }
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
//     }
// }

export default connect(getDataFromStore)(ResetPassword)
